module.exports = __webpack_public_path__ + "static/DPF-Dichtung-ebc4797d31ed03ab763defdd9e102258.jpg";